export enum MessageProcessingType {
    SendMessage = 'sendMessage',
    RespondWithMessage = 'respondWithMessage',
}
